__turbopack_context__.v({
  "mark-all-as-read-button": "mark-all-as-read-button-module-scss-module__T2HFWW__mark-all-as-read-button",
});
